import { HttpErrorResponse } from "@angular/common/http";
import { Component, ElementRef, HostListener, IterableDiffers, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSidenav } from "@angular/material/sidenav";
import { Router } from "@angular/router";
import { take } from "rxjs/operators";
import { IMenu } from "src/app/domain/interfaces/menu.interface";
import { AccessProfileService } from "src/app/domain/services/access-profile.service";
import { EnviromentsService } from "src/app/domain/services/enviroments.service";
import { LoginService } from "src/app/domain/services/login.service";
import { Safe2Go } from "src/app/domain/services/safe-2-go.service";
import { UtilsService } from "src/app/domain/services/utils.service";
import { DialogComponent } from "src/app/ui/dialog/dialog.component";
import { LoadComponent } from "src/app/ui/load/load.component";
import { environment } from "src/environments/environment";
import { CapturaInformacoesComputador } from "../../domain/helpers/obtem-dados-usuario";

@Component({
	selector: "app-default-layout",
	templateUrl: "./default-layout.component.html"
})
export class DefaultLayoutComponent implements OnInit {
	@ViewChild("default_layout") default: ElementRef;
	@ViewChild("sidenav") sidenav: MatSidenav;
	@ViewChild("sidenav_submenu") sidenav_submenu: MatSidenav;

	private token: string;
	private decoded: any;
	name: string;
	showAside = true;
	showSidenav = false;
	showSidenavSubMenu = false;
	hasBackdrop = false;
	listMenu: IMenu[] = [];
	accordionList: any;
	innerWidth: any;
	menu: IMenu;
	version = localStorage.getItem("systemVersion");
	private userGuidToRedis: string;
	private encodeUrl: string;

	constructor(
		private accessProfileService: AccessProfileService,
		private safe2Go: Safe2Go,
		private dialog: MatDialog,
		private router: Router,
		protected capturaInformacoesComputador: CapturaInformacoesComputador,
		private loginService: LoginService,
		private enviromentsService: EnviromentsService,
		private utilsService: UtilsService
	) {}

	ngOnInit() {
		this.token = localStorage.getItem("token");

		this.decoded = this.Decode(this.token);
		this.decoded.userNameRedis = this.utilsService.base642String(this.decoded.userNameRedis);
		this.decoded.name = this.utilsService.base642String(this.decoded.name);

		this.name = String(this.decoded.name).split(" ")[0];

		this.loadMenu();
		this.itemMenuActive(this.router.url);
	}

	@HostListener("window:resize", ["$event"])
	onResize() {
		this.innerWidth = window.innerWidth;
		if (this.sidenav.opened) {
			this.showAside = true;
			this.toggleResponsive();
		}
	}

	toggle() {
		this.hasBackdrop = false;
		this.showSidenavSubMenu = false;
		this.showSidenav = true;
		this.sidenav.mode = "side";
		this.sidenav_submenu.mode = "side";
		this.sidenav.toggle();
		if (this.sidenav.opened) {
			this.showAside = false;
		} else {
			this.showAside = true;
		}
	}

	selectedItemMenuAside(item: IMenu, action) {
		this.menu = item;
		this.showAside = true;
		switch (action.type) {
			case "click":
				{
					this.resetMenu();
					item.active = true;
					if (!this.showSidenav) {
						this.toggleSubMenu();
					}
				}
				break;
			case "mouseenter":
				{
					this.resetMenu();
					item.active = true;
					this.openToggleSubMenu();
				}
				break;
			default:
				{
					this.sidenav.close();
				}
				break;
		}
	}

	submenuMouseLeave() {
		this.showSidenavSubMenu = false;
		this.sidenav_submenu.close();
	}

	selectedItemMenuSidenav(item: IMenu) {
		this.resetMenu();
		item.active = true;
		this.menu = item;
		this.showAside = true;
		this.sidenav.close();
		this.toggleSubMenu();
	}

	toggleSubMenu(): void {
		this.showSidenavSubMenu = false;
		this.showSidenav = false;
		this.sidenav.mode = "over";
		this.showAside = true;
		this.sidenav.toggle();
	}

	openToggleSubMenu(): void {
		this.showSidenavSubMenu = false;
		this.showSidenav = true;
		this.sidenav.mode = "over";
		this.sidenav.open();
	}

	toggleResponsive(): void {
		this.hasBackdrop = false;
		this.showSidenavSubMenu = false;
		this.showSidenav = true;
		this.sidenav.mode = "side";
		this.sidenav_submenu.mode = "over";
		this.sidenav.toggle();
	}

	toggleResponsiveReturn(): void {
		this.sidenav.close();
		this.hasBackdrop = true;
		this.showSidenavSubMenu = true;
		this.showSidenav = false;
		this.sidenav.mode = "side";
		this.sidenav.toggle();
	}

	async navigatePage(page: string) {
		if (page != null) {
			this.toggleSubMenu();
			if (page.includes("mais-opcoes")) {
				const loadRef = this.dialog.open(LoadComponent, {
					panelClass: "custom-modalbox",
					disableClose: true
				});
				await this.safe2Go
					.login({ Page: page, UserId: 0 })
					.pipe(take(1))
					.toPromise()
					.then(response => {
						loadRef.close();
						if (response?.data.message?.length > 0) {
							const dialogRef = this.dialog.open(DialogComponent, {
								data: {
									title: "Atenção!",
									text: response.data.message
								},
								height: "238px",
								width: "480px",
								disableClose: true
							});
							dialogRef.componentInstance.secondNameButton = "ENTENDI";
							return;
						} else {
							window.open(response.data.url, "_blank");
							loadRef.close();
							return;
						}
					})
					.catch((responseError: HttpErrorResponse) => {
						loadRef.close();
					});
			} else if (this.isUrl(page)) {
				this.navigateToExternalPage(page);
			} else {
				this.router.navigate([page]);
			}
		}
	}

	retornaEnumCookie(titulo) {
		if (titulo === "Tomador") {
			return 3;
		} else if (titulo === "CCG Tomador") {
			return 4;
		} else if (titulo === "Segurado") {
			return 5;
		} else if (titulo === "Propostas") {
			return 6;
		} else if (titulo === "Estrutura Comercial") {
			return 7;
		} else if (titulo === "Tabela Recursal Tomador") {
			return 8;
		} else if (titulo === "Tabela Recursal") {
			return 9;
		} else if (titulo === "Cláusulas e Condições") {
			return 10;
		} else if (titulo === "Taxa Mix") {
			return 11;
		} else if (titulo === "Parâmetros e Cobertura") {
			return 12;
		} else if (titulo === "Perfil de Acesso") {
			return 13;
		} else if (titulo === "Usuário") {
			return 14;
		} else if (titulo === "Log de Erro") {
			return 15;
		} else if (titulo === "Log de Acesso") {
			return 16;
		} else if (titulo === "Trilha de Auditoria") {
			return 17;
		}
	}

	itemMenuActive(page: string): void {
		this.listMenu.forEach(item => {
			if (item.page === page) {
				item.active = true;
			}
		});
	}

	resetMenu(): void {
		this.listMenu.forEach(item => {
			item.active = false;
		});
	}

	loadMenu(): void {
		const loadRef = this.dialog.open(LoadComponent, {
			panelClass: "custom-modalbox",
			disableClose: true
		});
		this.listMenu = [];
		let listSubMenu: IMenu[];
		let listSubMenuLv1: IMenu[];
		this.accessProfileService.getProfiliesClaims().subscribe(
			res => {
				this.userGuidToRedis = res.data.userGuidToRedis;
				res.data.claims.forEach(menu => {
					// SUBMENU
					if (menu.claims.length) {
						listSubMenu = [];

						menu.claims.forEach(subMenu => {
							listSubMenuLv1 = [];

							if (subMenu.actions.includes("read")) {
								listSubMenu.push({
									icon: subMenu.icone,
									title: subMenu.description,
									page: subMenu.link,
									submenu: listSubMenuLv1,
									showMenuOption: subMenu.showMenuOption,
									isLinkParamToRedis: subMenu.isLinkParamToRedis,
									isLinkExternalPage: subMenu.isLinkExternalPage
								});

								subMenu.claims.forEach(subMenuLv1 => {
									if (subMenuLv1.actions.includes("read")) {
										listSubMenuLv1.push({
											icon: subMenuLv1.icone,
											title: subMenuLv1.description,
											page: subMenuLv1.link
										});
									}
								});
							}
						});
					}

					this.listMenu.push({
						icon: menu.icone,
						title: menu.description,
						page: menu.link,
						active: false,
						submenu: listSubMenu,
						submenuLv1: listSubMenuLv1,
						showMenuOption: menu.showMenuOption,
						isLinkParamToRedis: menu.isLinkParamToRedis,
						isLinkExternalPage: menu.isLinkExternalPage
					});

					listSubMenu = undefined;
					listSubMenuLv1 = undefined;
				});
				loadRef.close();
			},
			error => {
				loadRef.close();
			}
		);
	}

	Decode(token: string) {
		try {
			return JSON.parse(atob(token.split(".")[1]));
		} catch (e) {}
	}

	menuHasLevels(item) {
		return item.submenu.length > 0;
	}

	selectSubmenuSidenav(item) {
		this.resetMenu();
		item.active = true;
		this.menu = item;

		if (item.page && item.isLinkExternalPage) {
			window.open(item.page, "_blank");
		} else if (item.page && item.isLinkParamToRedis) {
			this.navigateToExternalPage(item.page);
		} else if (item.page && !item.isLinkParamToRedis) {
			this.navigatePage(item.page);
		} else {
			this.openSidenavSubmenu();
		}
	}

	openSidenavSubmenu() {
		this.sidenav_submenu.open();
		this.sidenav_submenu.mode = "over";
		this.showSidenavSubMenu = true;
	}

	closeSidenavSubmenu() {
		this.sidenav_submenu.close();
		this.sidenav_submenu.mode = "over";
		this.showSidenavSubMenu = false;
	}

	private navigateToExternalPage(urlPage: string): void {
		if (!!urlPage) {
			this.toggleSubMenu();
			this.encodeUrl = btoa(`${this.getPartName(urlPage)}?HideHeader=true&uid=${this.userGuidToRedis}`);
			this.encodeUrl = this.encodeUrl.replace(/\+/gi, ".");
			this.encodeUrl = this.encodeUrl.replace(/\//gi, "_");
			this.encodeUrl = this.encodeUrl.replace(/\=/gi, "-");

			this.router.navigate(["/"]).then(() => {
				this.router.navigate([`pagina-externa/${this.encodeUrl}`]);
			});
		}
	}

	private getPartName(urlPage: string) {
		try {
			const validUrl = new URL(urlPage);
			return validUrl.pathname;
		} catch {
			return urlPage;
		}
	}

	private isUrl(urlPage: string) {
		try {
			const validUrl = new URL(urlPage);
			return true;
		} catch {
			return false;
		}
	}
}
